<template>
    <Card>
        <Tabs :value="initTabValue" @on-click="tabClick">
            <template v-for="(tabpane, i) in attrs.children">
                <TabPane :label="tabpane.title" :name="i+''">
                    
                </TabPane>
            </template>
        </Tabs>

        <template v-for="el in attrs.children[initTabValue].children">
            <ly-hoc :attrs="el"></ly-hoc>
            <div class="space"></div>
        </template>

        <Spin size="large" fix v-if="spinShow"></Spin>
    </Card>
</template>
<script>
    /**
     * 标签页面
     * 每个tabPan需要的配置
     * {
     *      title: '标签title一',
            push_api: 'api/admin/democustomergl', // 提交数据的API
            api: 'api/admin/democustomergl', // 拉取数据的API
			type: 'a', // a：新增，i：详情，e：修改
			methods: 'POST', // 提交类型
			children: []
     * }
     */
    import CompSendMixin from '@/utils/compSend.mixin'
    export default {
        name: 'LyTab',
        mixins: [CompSendMixin],
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                initTabValue: '0', // 初始化默认显示
                renderConfig: {}, // 当前渲染的配置
                tabPaneKey: 'TAB_PANE_KEY', // 本地存储当前标签显示在第几页
                cacheData: [], // 存储拉取到的数据
                spinShow: false,
                timer: null
            }
        },
        watch: {
            '$route' () {
                this.init()
            }
        },
        created () {
            this.init()
        },
        methods: {
            init () {
                // 设置默认选中项
                let localIndex = localStorage.getItem(this.tabPaneKey)
                if (localIndex != null && !isNaN(localIndex) && this.attrs.children && this.attrs.children.length > localIndex) {
                    this.initTabValue = localIndex
                    this.pullData()
                } else {
                    this.tabClick(this.initTabValue)
                }
            },
            tabClick (e) {
                this.spinShow = true
                this.initTabValue = e
                this.timer = setTimeout(() => {
                    this.spinShow = false
                }, 1500)
                localStorage.setItem(this.tabPaneKey, e)
                this.pullData()
                this.$nextTick(() => {
                    clearTimeout(this.timer)
                    this.spinShow = false
                })
            },
            /**
             * 根据标签页类型拉取数据
             */
            pullData () {
                let pane = this.attrs.children[this.initTabValue]
                // 新增模式和修改模式拉取数据
                if (pane.type == 'a' || pane.type == 'e') {
                    this.sendSubmitMethodData({
                        api: pane.push_api || pane.api,
                        method: pane.method
                    })
                }
                // 详情模式和修改模式进行数据的拉取
                if (pane.type == 'i' || pane.type == 'e') {
                    // 如果已经拉取过了数据，就不再进行数据请求
                    // if (this.cacheData[this.initTabValue]) {
                    //     this.$eventHub.$emit(this.$events.PAGE_DATA, this.cacheData[this.initTabValue])
                    // } else {
                        // 通过路由参数匹配api
                        let url = this.$path.getPath(pane.api, this.$route.params)
                        //请求页面数据
                        this.$api.query(url).then((rs) => {
                            this.cacheData[this.initTabValue] = rs
                            // 向所有子组件，发送数据
                            this.$eventHub.$emit(this.$events.PAGE_DATA, rs)
                        }).catch((err) => {
                            this.$Message.error({content: err, duration: 5 })
                        })
                    // }
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// ../projectCore/src/components/tab/src/index.vue